module.exports = __webpack_public_path__ + "static/media/logo.86cd98d7.png";